const STATUS_STYLES = {
  pending: {
    badge: "bg-yellowlight/20 text-yellowdark border border-yellowstar",
  },
  preparing: {
    badge: "bg-yellow-100 text-yellow-700 border border-yellow-300",
  },
  ready: {
    badge: "bg-blue-100 text-blue-700 border border-blue-300",
  },
  completed: {
    badge: "bg-green-100 text-green-700 border border-green-300",
  },
  cancelled: {
    badge: "bg-red-100 text-red-600 border border-red-300",
  },
};

const STATUS_LABELS = {
  pending: "New Order",
  preparing: "Preparing",
  ready: "Ready for Pickup",
  completed: "Completed",
  cancelled: "Cancelled",
};

const StatusBadge = ({ status }) => {
  return (
    <span
      className={`text-xs px-2 py-1 rounded-full border ${
        STATUS_STYLES[status]?.badge
      }`}
    >
      {status}
    </span>
  );
};

export default StatusBadge;
